import React from "react";

const CommonLoading = () => {
  return (
    <div className=" w-100 d-flex text-centeralign-items-center justify-content-center ">
      <div className=" spinner-border "></div>
    </div>
  );
};

export default CommonLoading;
